import { posthog } from 'posthog-js';

import {
    VERIFY_TOKEN_REQUEST,
    VERIFY_TOKEN_SUCCESS,
    VERIFY_TOKEN_FAILURE,
} from '../constants/Authentication';

import currentUserApi from '../resources/currentUser';
import { usersCurrentClientId } from '../../../util/hasAccess';

export function verifyToken(token) {
    return function (dispatch) {
        verifyTokenRequest();

        return currentUserApi
            .get(token)
            .then((response) => {
                if (
                    process.env.REACT_APP_POSTHOG_PROJECT_API_KEY &&
                    response.id
                ) {
                    const [, emailDomain] = response.email.split('@');
                    posthog.identify(`${response.id}`, {
                        clientId: usersCurrentClientId(response),
                        emailDomain,
                        id: response.id,
                        role: response.role,
                    });
                }

                // if (response.type !== 'ADMIN') {
                //     dispatch(verifyTokenFailure(token, {}));
                //     return;
                // }

                dispatch(verifyTokenSuccess(token, response));
            })
            .catch((error) => {
                console.log('ERROR', error);

                if (process.env.REACT_APP_POSTHOG_PROJECT_API_KEY) {
                    posthog.reset();
                }

                dispatch(verifyTokenFailure(token, error));
            });
    };
}

export function verifyTokenRequest() {
    return {
        type: VERIFY_TOKEN_REQUEST,
    };
}

export function verifyTokenSuccess(token, user) {
    return {
        type: VERIFY_TOKEN_SUCCESS,
        payload: {
            token: token,
            user: user,
        },
    };
}

export function verifyTokenFailure(token, data) {
    let errorData = {};
    if (data.error !== undefined && data.error.status !== undefined) {
        errorData.status = data.error.status;
    }

    if (
        data.tokenDeveloperMessage !== undefined &&
        data.error.tokenDeveloperMessage !== undefined
    ) {
        errorData.tokenDeveloperMessage = data.error.tokenDeveloperMessage;
    }

    return {
        type: VERIFY_TOKEN_FAILURE,
        payload: {
            token: token,
            status: errorData.status,
            tokenDeveloperMessage: errorData.tokenDeveloperMessage,
        },
    };
}
